import React, { useContext } from 'react';

import { WindowSizeContext } from 'contexts';
import { FormField, Label } from 'components/ui';
import FormErrorPopover from 'components/ui/Form/FormErrorPopover/FormErrorPopover';
import Typography from 'components/ui/Typography';

import css from './FormFieldWithError.module.scss';

interface Props extends React.PropsWithChildren {
    label?: string;
    errorMessage?: string;
    isVisible?: boolean;
    placement?: 'left' | 'right';
}

const FormFieldWithError: React.FC<Props> = ({ children, label, isVisible, errorMessage, placement = 'left' }) => {
    const { isMobile } = useContext(WindowSizeContext);

    return !isMobile ? (
        <FormField>
            {label && <Label text={label} />}
            <FormErrorPopover placement={placement} content={errorMessage} visible={isVisible}>
                {children}
            </FormErrorPopover>
        </FormField>
    ) : (
        <FormField>
            {label && <Label text={label} />}
            {children}
            {isVisible && (
                <Typography color="red" className={css.errorMessage}>
                    {errorMessage}
                </Typography>
            )}
        </FormField>
    );
};

export default FormFieldWithError;
